export var Errors;
(function(Errors) {
    Errors["LANDING_ALERTS_FETCH_ERROR_API_ERROR"] = "Landing alerts - Fetch error - API error";
    Errors["LANDING_RESULTS_API_ERROR"] = "Landing Results - API error";
})(Errors || (Errors = {}));
